import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Overview", href: "#overview" },
  { label: "Amenities", href: "#amenities" },
  { label: "Floor Plans", href: "#floorplans" },
  { label: "Gallery", href: "#gallery" },
  { label: "Location", href: "#location" },
  { label: "Contact", href: "#contact" },
  { label: "Privacy Policy", href: "/privacy-policy", internal: true },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-serif text-2xl tracking-tight mb-4">
              La <span className="text-[#C5A059]">VALORA</span>
            </h3>
            <p className="font-serif italic text-white/50 text-sm mb-6">
              home today, heritage tomorrow.
            </p>
            <p className="text-xs text-white/30 uppercase tracking-wider">
              By Reliance Builders
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  {link.internal ? (
                    <Link
                      to={link.href}
                      className="text-sm text-white/60 hover:text-[#C5A059] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-sm text-white/60 hover:text-[#C5A059] transition-colors"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              {/* <a
                href="tel:+919663862557"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C5A059] transition-colors"
              >
                <Phone size={14} /> +91 9663862557
              </a> */}

              <div className="flex items-start gap-3 text-sm text-white/60">
                <MapPin size={14} className="mt-0.5 flex-shrink-0" />
                <span>Kardanur, Telangana 502300</span>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Legal
            </h4>
            <div className="space-y-3 text-xs text-white/40 leading-relaxed">
              <p>RERA No: P01100010542</p>
              <p>HMDA Permission No: 012817/LO/HMDA/3450/SKP/2024</p>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 flex flex-col md:flex-column justify-between items-center gap-4">
          <p className="text-xs text-white/30">
            A quick but important clarification: Reliance Builders is a
            Hyderabad regional developer, founded in 1988, with no connection
            whatsoever to Reliance Industries or the Ambani group. The names are
            coincidental. "Revasa" is Reliance Builders' contemporary brand line
            - the about-builder page covers the developer in full.
          </p>
          <p className="text-xs text-white/20 uppercase tracking-wider">
            Keyon Properties is an authorized channel partner for this project.
            We are not the official website of the developer or promoter. The
            information, images, specifications, floor plans, pricing, and other
            details presented on this website are provided for informational and
            illustrative purposes only and do not constitute a legal offer,
            advertisement, or commitment of any nature. The project details are
            subject to change at the sole discretion of the developer/promoter
            without prior notice. Prospective buyers are advised to verify all
            project information, approvals, specifications, availability,
            pricing, and terms directly with the developer before making any
            purchase decision. RERA Registration No.: A02400001347 By using this
            website, you acknowledge and agree that Keyon Properties acts solely
            as a marketing and sales facilitator and shall not be held
            responsible for any changes, discrepancies, or decisions made by the
            developer/promoter.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Revesa La Valora . All rights
            reserved.
          </p>
          <p className="text-xs text-white/20 uppercase tracking-wider">
            Value Built on Values
          </p>
        </div>
      </div>
    </footer>
  );
}
